import { CAPTION_CLASS } from '../financial.type.component';

const OPTION_BASE_CLASS = 'rounded-lg border px-3.5 py-2 text-xs transition-colors';

const OPTION_SELECTED_CLASS = 'border-[#376fd0] bg-[#F2F6FD] text-[#264884]';

const OPTION_IDLE_CLASS = 'border-[#e3e6ec] bg-white text-gray-500 hover:border-[#b9c6de]';

const labelOf = (link) => [link.serviceName || link.label, link.responsibleName].filter(Boolean).join(' · ');

export default function AdjustmentLinkPicker({ links, selectedResponsibleId, onSelect }) {

    if (links.length < 2) return null;

    return (
        <div className="mb-6">
            <p className={['mb-3', CAPTION_CLASS].join(' ')}>
                Qual vínculo você quer editar
            </p>

            <div className="flex flex-wrap gap-2.5">
                {links.map((link) => (
                    <button
                        key={link.responsibleId}
                        type="button"
                        onClick={() => onSelect(link)}
                        className={`${OPTION_BASE_CLASS} ${String(link.responsibleId) === String(selectedResponsibleId) ? OPTION_SELECTED_CLASS : OPTION_IDLE_CLASS}`}
                    >
                        {labelOf(link)}
                    </button>
                ))}
            </div>
        </div>
    );
}
